import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import ContactForm from './widget/component/ContactForm';

const initSpecificPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('contact-form', ContactForm, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecificPageWidgets.bind(this));
} else {
    initSpecificPageWidgets();
}